import { useMemo } from 'react';
import { useFeatureFlags } from '@funtech-int/yango-shared';

import { featureFlagsScheme } from '../../../../lib/featureFlags';

function getTestIds(testIds: string[]): number[] {
    return testIds.reduce<number[]>((acc, testId) => {
        const numberTestId = Number(testId);

        if (Number.isInteger(numberTestId)) {
            acc.push(numberTestId);
        }

        return acc;
    }, []);
}

export const usePlayerTestIds = (): number[] => {
    const { testIds } = useFeatureFlags(featureFlagsScheme);

    return useMemo(() => getTestIds(testIds), [testIds]);
};
